<template>
  <ul id="list-tasks">
    <li>
      <div class="oblea" @click="selectItem">
        <div id="imagenProductoContainer">
          <img id="check" src="/dist/icon-check.png"  v-show="item.showCheck" />
          <img id="imagenPlaceholder" src="/dist/progress-item.gif"  v-show='imagenProducto == null'  style="width:40px; height:40px;" />
          <img id="imagenProducto" :src="imagenProducto" :title="item.Nombre"  v-show='imagenProducto != null'/>
        </div>
        <p id="labelProducto" v-show='showNombre'>{{item.Nombre}}</p>
      </div>
    </li>
  </ul>
</template>


<script>
  import axios from 'axios'

  export default {
    name: 'item-realizar-pedido',
    props: ['item'],
    data() {
      return {
        imagenProducto: null,
      }
    },
    computed: {

      showNombre() {
        if (this.$store.state.pedido.seleccion == 1)
        {
          return false;
        }
        else
        {
          return true;
        }
      },

    },

    watch: {
      item: {
        immediate: true,
        handler  () {
          this.getImage()
        }
      }
    },

    methods: {

      selectItem: function () {
         this.$emit('setItem', this.item.Id);
      },

      getImage () {
        this.imagenProducto = null
        if (this.item.ArchivoId != null)
        {
          var img = this.$store.state.pedido.imagenes.find( e => e.id === this.item.ArchivoId);
          if (img != null)
          {
            this.imagenProducto = img.image
          }
          else
          {
            let config = {
              method: 'GET',
              responseType: 'blob',
              url:'/WebSalesArchivo?ArchivoId='+this.item.ArchivoId+'&Ancho=150',
              headers: {
                        Token:this.$store.state.user.token,
                        ClientSecret: process.env.CLIENT_SECRET,
                        EmpresaId: process.env.EMPRESA_ID
                       }
            }
            axios
            .request(config)
            .then(response => {
              let reader = new FileReader()
              reader.onload = () => {
                if (this.imagenProducto == null)
                {
                  this.imagenProducto = reader.result
                  var img = {id:this.item.ArchivoId,image:this.imagenProducto}
                  this.$store.commit('pedido/saveImage',img)
                }
              }
              console.log(response.data)
              reader.readAsDataURL(response.data)
            })
            .catch(err => {
              this.imagenProducto = '/dist/placeholder-producto.png'
            })

          }
        }
      },
    },

    created () {
      this.getImage();
    },

   }
</script>






<style scoped>

#check{
    position: absolute;
    width: 20px;
    left: 117px;
    top: 5px;
    z-index: 1;
    display: block;
  }


#imagenProductoContainer{
    width: 110px;
    height: 100px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 10px;
    border-width: 1px;
    border: 1px solid #dddddd;
    padding: 10px 15px 10px 15px;
    box-shadow: 4px 4px 7px #dddddd;
  }


#imagenProducto{
    position: relative;
    max-width: 100%;
    max-height: 100%;
    margin: 0 auto;
    display: block;
    border-radius: 10 px;
  }


 * {
   margin:  0;
   padding: 0;
  }


  li {
   float: left;
   display: block;
   padding: 10px;
   text-decoration: none;
  }

.oblea{
    position: relative;
    width: 130px;
    height: 135px;
    background: #ffffff;
  }

  #imagenProductoContainer:hover{
    cursor: pointer;
    background: #f9f9f9;
  }

#labelProducto{
  margin-top: 8px;
  text-align: center;
  font-size:10px;
  font-weight: 500;
  background-color: #ffffff;
  color: #4969B2;
  }


 </style>



// WEBPACK FOOTER //
// src/components/views/realizarPedido/itemRealizarPedido.vue